<template>
	<div class="page-style-a">
		<div class="container">
			<div class="page-intro">
				<h2>Detail</h2>
				<ul class="bread-crumb">
					<li class="has-separator">
						<i class="ion ion-md-home"></i>
						<router-link :to="{name : 'Home'}">Home</router-link>
					</li>
					<li class="is-marked">
						<a href="single-product.html">Detail</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<div style="height: 4rem">
		<Spinner v-if="status.selectedProduct.loading" />
	</div>
	<div class="page-detail">
		<div class="container" v-if="!status.selectedProduct.loading">
			<!-- Product-Detail -->
			<ProductMain />
			<!-- Product-Detail /- -->
			<!-- Detail-Tabs -->
			<div class="row">
				<div class="col-lg-12 col-md-12 col-sm-12">
					<div class="detail-tabs-wrapper u-s-p-t-80">
						<div class="detail-nav-wrapper u-s-m-b-30">
							<ul class="nav single-product-nav justify-content-center">
								<li class="nav-item">
									<a class="nav-link active" data-toggle="tab" href="#description">Description</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" data-toggle="tab" href="#specification">Specifications</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" data-toggle="tab" href="#review">Reviews</a>
								</li>
							</ul>
						</div>
						<div class="tab-content">
							<!-- Description-Tab -->
							<ProductDesc />
							<!-- Description-Tab /- -->
							<!-- Specifications-Tab -->
							<ProductSpecs />
							<!-- Specifications-Tab /- -->
							<!-- Reviews-Tab -->
							<ProductReview />
							<!-- Reviews-Tab /- -->
						</div>
					</div>
				</div>
			</div>
			<!-- Detail-Tabs /- -->
			<!-- Different-Product-Section -->
			<div class="detail-different-product-section u-s-p-t-80">
				<section class="section-maker" v-if="isLoggedIn">
					<ProductRecently />
				</section>
				<section class="section-maker">
					<ProductSimilar />
				</section>
				<section class="section-maker">
					<MostViewedProducts />
				</section>
			</div>
			<!-- Different-Product-Section /- -->
		</div>
	</div>
	<SubscriptionModal />
	<Footer />
</template>

<script>
	import ProductMain from "./ProductMain.vue";
	import ProductDesc from "./ProductDesc.vue";
	import ProductSpecs from "./ProductSpecs.vue";
	import ProductReview from "./ProductReview.vue";
	import ProductSimilar from "./ProductSimilar.vue";
	import ProductRecently from "./ProductRecently.vue";
	import MostViewedProducts from "./MostViewedProducts.vue";
	import Footer from "../../../Bottom/Footer.vue";
	import Spinner from "../../../Loaders/Spinner.vue";
	import {mapActions, mapState} from "vuex";
	import SubscriptionModal from "../../../Modals/SubscriptionModal.vue";

	export default {
		components: {
			ProductMain,
			ProductDesc,
			ProductSpecs,
			ProductReview,
			ProductSimilar,
			ProductRecently,
			MostViewedProducts,
			Spinner,
			Footer,
			SubscriptionModal,
		},
		computed: {
			...mapState("products", ["status", "selectedProduct"]),
			...mapState("auth", ["isLoggedIn"]),
		},
		data() {
			return {
				loading: true,
				product: null,
			};
		},
		methods: {
			...mapActions("products", ["getProductById"]),
		},

		mounted() {
			// this.getProductById();
			let productId = this.$route.params.id;
			this.getProductById(productId);
		},
		watch: {
			$route(to, from) {
				if (to.params.id) {
					this.getProductById(to.params.id);
				}
			},
		},
	};
</script>

<style></style>
